import { ApiError } from '@lib/network/api';
import { userStore } from '@stores/User';
import { useNavigate } from 'react-router';
import { AuthConsumeStatus } from '../AuthConsumeStatus';
import { AUTH_ERROR_CODES, isRateLimitError } from '../authErrors';
import { useConsumeCode } from '../useConsumeCode';

export function MagicLinkPage() {
  const navigate = useNavigate();
  const { error } = useConsumeCode({
    consume: userStore.consumeMagicLink,
    missingCodeRedirect: '/login',
    successRedirect: '/',
    errorToMessage: (e) =>
      e instanceof ApiError && e.code === AUTH_ERROR_CODES.magicLinkInvalid
        ? 'This sign-in link is invalid or has expired.'
        : isRateLimitError(e)
          ? 'Too many attempts. Please try again later.'
          : 'Something went wrong. Please try again.',
  });

  return (
    <AuthConsumeStatus
      error={error}
      loadingText="Signing you in..."
      retryLabel="Request a new link"
      onRetry={() => navigate('/login?mode=magic-link&msg=expired')}
    />
  );
}
